const m = window.require("@ember/debug");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;